export default "__VITE_ASSET__nu7_yW2S__"